import React, { useState, createContext, useContext } from 'react'

const TwoFactorContext = createContext({
  twoFactorAuthData: {
    email: '',
    sms: '',
    hasSentContactType: false,
    selectedContactType: 'email',
    hasExpirationCodeVerified: false
  },
  handleChangeTwoFactorData: userData => {}
})

export function TwoFactorProvider({ children }) {
  const [twoFactorAuthData, setTwoFactorAuthData] = useState({
    email: '',
    sms: '',
    hasSentContactType: false,
    selectedContactType: 'email',
    hasExpirationCodeVerified: false
  })

  function handleChangeTwoFactorData(newData) {
    setTwoFactorAuthData(prevData => {
      return {
        ...prevData,
        ...newData
      }
    })
  }

  return (
    <TwoFactorContext.Provider
      value={{
        handleChangeTwoFactorData,
        twoFactorAuthData
      }}
    >
      {children}
    </TwoFactorContext.Provider>
  )
}

export function useTwoFactor() {
  const context = useContext(TwoFactorContext)

  return context
}
